import { Component, OnInit, OnDestroy, Input, HostListener } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CartService } from '../../services/cart.service';
import { restaurants, menuItems, Restaurant, MenuItem } from '../../data/mock';
import { Product } from '../../Model/product';
import { FileServiceService } from '../../services/file-service.service';
import { MatrixDto } from '../../Model/matrix-dto';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { LocalStorageService } from '../../services/local-storage.service';
import { WebOrderMinimumDateTimeSetup } from '../../Model/web-order-minimum-date-time-setup';
import moment from 'moment';
import { ProductService } from '../../services/product.service';
import { WebOrderStockDetailsDto } from '../../Model/web-order-stock-details-dto';
import { ToastService } from '../../services/toast.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonExternalModule } from '../../common/common-external-module';
import { ProductsWithWebOrderOffers } from '../../Model/products-with-web-order-offers';
import { GoogleCustomer } from '../../Model/googlecustomer';
import { StorePickupDialogComponent } from '../../dialog/store-pickup-dialog/store-pickup-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ViewOfferSetUpDto } from '../../Model/view-offer-set-up-dto';
import { OfferDialogComponent } from '../../dialog/offer-dialog/offer-dialog.component';
import { BulkDiscountDto } from '../../Model/bulk-discount-dto';

@Component({
  selector: 'app-restaurant',
  standalone: true,
  imports: [CommonExternalModule, HeaderComponent, FooterComponent],
  templateUrl: './restaurant.component.html',
  styleUrl: './restaurant.component.css',
})

export class RestaurantComponent implements OnInit, OnDestroy {
  @Input() aggregatorSetup: any;
  searchQuery = '';
  filterType: 'all' | 'veg' | 'nonveg' | null = 'all';
  cartCount = 0;
  currentUrl: string;
  selectedSubGroup: string | null = null;
  subGroups: string[] = [];
  storeLatitudeMap: number | null = null;
  storeLongitudeMap: number | null = null;
  deliveryType: string;
  googleCustomer: GoogleCustomer;

  restaurant: Restaurant | undefined;
  items: Product[] = [];
  allProductList: Product[] = [];
  matrixList: MatrixDto[] = [];
  webOrderMinimumDateTimeList: WebOrderMinimumDateTimeSetup = new WebOrderMinimumDateTimeSetup();
  timeSlot2: string[][] = [];
  timeSlotAvl: string[] = [];
  productList: Product[] = new Array(1200);
  timestamp = Date.now();
  productWithOffers: ProductsWithWebOrderOffers[];
  offerTypeArray: string[] = [];

  //Subscription
  private cartSubscription!: Subscription;
  private webOrderBestSellersSubcription: Subscription;
  private checkAllowStockSubscription: Subscription;
  private getAggregatorSetupSubscription: Subscription;
  private offerSubscription: Subscription;
  private getDesignSubscription: Subscription;
  private productOfferSubscription: Subscription;
  private productDiscountSubscription: Subscription;
  private productBulkDiscountSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cartService: CartService,
    private fileService: FileServiceService,
    private apiFactory: ApiFactoryEndPoints,
    private localStorage: LocalStorageService,
    public productService: ProductService,
    private toastrService: ToastService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.isDesktop = window.innerWidth >= 768;
    this.currentUrl = window.location.host.replace(':', '');
    this.deliveryType = JSON.parse(this.localStorage.getItem("delivery_type"));
    this.matrixList = this.fileService.getFileData("matrixList");
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    this.matrixList.forEach(m => {
      restaurants.forEach(r => {
        if (m.productMatrixName == r.name) {
          r.id = m.refNo;
        }
      })
    })
    this.allProductList = this.fileService.getFileData("allProductList");
    const id = Number(this.route.snapshot.paramMap.get('id'));
    this.restaurant = restaurants.find(r => r.id === id);
    this.productList = this.allProductList;

    // this.items = menuItems[id] || menuItems[1] || [];
    this.items = this.allProductList.filter(e =>
      e.productSubGroup?.productGroup?.productMatrix?.refNo == id
    );

    this.subGroups = Array.from(
      new Set(
        this.items
          .map(e => e.productSubGroup?.productSubGroupName)
          .filter(name => !!name)
      )
    );

    this.getWebOrderBestProductSetUpList();
    this.setCurrentLocationStore();
    this.getOfferDetails();
    this.getProductDeliveryTimeAndStockDetails();
  }

  ngOnDestroy() {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }

    if (this.getAggregatorSetupSubscription) {
      this.getAggregatorSetupSubscription.unsubscribe();
    }
  }

  private setCurrentLocationStore(): void {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Location permission granted, get coordinates
          this.storeLatitudeMap = position.coords.latitude;
          this.storeLongitudeMap = position.coords.longitude;
          console.log('Latitude:', this.storeLatitudeMap, 'Longitude:', this.storeLongitudeMap);

          // Call API with the fetched location
          this.getAggregatorSetup();
        },
        (error) => {
          // Handle errors
          switch (error.code) {
            case error.PERMISSION_DENIED:
              this.toastrService.showErrorToast('Location permission denied. Please allow location access in your browser settings.');
              break;
            case error.POSITION_UNAVAILABLE:
              this.toastrService.showErrorToast('Location information is unavailable. Please try again later.');
              break;
            case error.TIMEOUT:
              this.toastrService.showErrorToast('The request to get user location timed out. Please try again.');
              break;
            default:
              this.toastrService.showErrorToast('An unknown error occurred. Please try again.');
              break;
          }

          // Call API with null latitude & longitude (Location disabled case)
          this.storeLatitudeMap = null;
          this.storeLongitudeMap = null;
          this.getAggregatorSetup();
        },
        {
          enableHighAccuracy: true,
          timeout: 30000,
          maximumAge: 0
        }
      );
    } else {
      // If browser does not support geolocation
      this.toastrService.showErrorToast('Geolocation is not supported by your browser.');

      // Call API with null values
      this.storeLatitudeMap = null;
      this.storeLongitudeMap = null;
      this.getAggregatorSetup();
    }
  }

  getAggregatorSetup() {
    this.getAggregatorSetupSubscription = this.productService.getAggregatorSetup(this.apiFactory.getAggregatorSetupByUrl,
      this.currentUrl, this.storeLatitudeMap != null ? this.storeLatitudeMap.toString() : null, this.storeLongitudeMap != null ? this.storeLongitudeMap.toString() : null)
      .subscribe(data => {
        this.aggregatorSetup = data;
      });
  }

  getWebOrderBestProductSetUpList() {
    this.webOrderBestSellersSubcription = this.cartService
      .getWebOrderBestProductSetup(
        this.apiFactory.getBestProducts,
        this.currentUrl
      )
      .subscribe((data) => {
        this.allProductList.forEach(e => {
          data.forEach(d => {
            if (e.product_Code == d.product_Code) {
              e.bestseller = true;
            }
          })
        })
      });
  }

  getOfferDetails() {
    let productId: number[] = this.allProductList.map(element => element.product_Code);
    if (productId.length === 0) return;

    let type = this.deliveryType ? (this.deliveryType === 'storePickup' ? 'Pickup' : 'Delivery') : null;

    const fetchOfferDetails = (locId: number) => {
      this.offerSubscription = this.productService.getOfferDetails(this.apiFactory.getOfferDetails, locId, productId, this.currentUrl)
        .subscribe((data: any) => {
          this.processOfferDetails(data);
        });
    };

    if (!type) {
      fetchOfferDetails(0);
      return;
    }

    this.offerSubscription = this.productService.getOfferAllowFor(this.apiFactory.getOfferAllowFor, this.currentUrl, type)
      .subscribe((response: any) => {
        if (response.data === 'Not Available') {
          console.log("No offers available.");
          return;
        }

        let locId = 0;
        if (response.data === 'allowForWebsite') {
          locId = this.googleCustomer?.locationCode || 0;
        } else if (response.data === 'allowForLocation') {
          locId = JSON.parse(this.localStorage.getItem('location_code')) || 0;
        }
        fetchOfferDetails(locId);
      });
  }

  processOfferDetails(data: any) {
    this.productWithOffers = data;
    console.log(this.productWithOffers);

    this.offerTypeArray = [];

    if (this.productWithOffers.length > 0) {
      this.productWithOffers.forEach(element => {
        element.offerDetails.forEach(offerDetails => {
          if (!this.offerTypeArray.includes(offerDetails.schemeType)) {
            this.offerTypeArray.push(offerDetails.schemeType);
          }
        });
      });
    }

    [this.allProductList, this.productList].forEach(productList => {
      productList.forEach(element => {
        let arr = this.productWithOffers.filter(offer => offer.productCode === element.product_Code);
        if (arr.length !== 0) {
          element.offerDetails = arr[0].offerDetails;
          element.offers = arr[0].offers;
        }
      });
    });

    // if (this.filter === 'offers') {
    //   this.isCollapsed['offer'] = !this.isCollapsed['offer'];
    //   this.selectedFilters.offers = ['Buy X get Y Free'];
    //   this.productList = this.allProductList.filter(product =>
    //     product.offerDetails?.some(offerDetails => offerDetails.schemeType === 'Buy X get Y Free')
    //   );
    //   this.productCode = this.productList.map(product => product.product_Code);
    //   if (this.category) {
    //     this.filterProducts();
    //   }

    // }
    // if (!this.filter && this.selectedFilters.offers.length > 0) {
    //   this.applyFilters();
    //   this.expandAndCollapseAllFilters();
    // }
    console.log(this.productList);
  }

  // get filteredItems(): Product[] {
  //   return this.items.filter(item => {
  //     const matchesSearch = item.product_Name.toLowerCase().includes(this.searchQuery.toLowerCase());
  //     const matchesFilter =
  //       this.filterType === 'all' ||
  //       (this.filterType === 'veg' && item.food_Type == "Veg") ||
  //       (this.filterType === 'nonveg' && item.food_Type == "Non-Veg");

  //     return matchesSearch && matchesFilter;
  //   });
  // }

  // async addToCart(product: Product) {
  //   // this.toastrService.showWarningToast('We’re working on this');
  //   // return;
  //   const locId = JSON.parse(this.localStorage.getItem('location_code'));
  //   let selectedProduct = product;

  //   if (!locId) {
  //     await this.getProductDeliveryTimeAndStockDetails();

  //     const updatedProduct = this.productList.find(
  //       p => p.product_Code === product.product_Code
  //     );
  //     if (updatedProduct) {
  //       selectedProduct = updatedProduct;
  //     }
  //   }
  //   // Apply delivery logic only once
  //   this.setDelivery(selectedProduct);
  // }

  addToCart(product: Product) {
    console.log(product);
    // if (this.specialProductCodes.includes(Number(product.product_Code))) {
    //   this.toastrService.showWarningToast('Coming soon.');
    //   return;
    // }
    this.openDeliveryTypeDialog(product);
  }

  openDeliveryTypeDialog(product: Product) {
    let deliveryType = JSON.parse(this.localStorage.getItem('delivery_type'));
    let locId = JSON.parse(this.localStorage.getItem('location_code'));
    console.log('Delivery Type:', deliveryType, 'Location ID:', locId);
    if (!deliveryType || !locId) {
      const dialogRef = this.dialog.open(StorePickupDialogComponent, {
        width: '300px',
        autoFocus: false,
        panelClass: 'store-dialog-container'
      });

      dialogRef.afterClosed().subscribe(async result => {
        console.log(result)
        if (result) {
          await this.getProductDeliveryTimeAndStockDetails(); // wait for API to update productList
          const updatedProduct = this.productList.find(p => p.product_Code === product.product_Code);
          if (result === 'storePickup') {
            // this.setStorePickup(updatedProduct, goToCartPage);
          }
          else if (result === 'delivery') {
            this.setDelivery(updatedProduct);
            // this.openPinDialog(product, goToCartPage);
          }
        }
      });
    } else {
      if (deliveryType === 'storePickup') {
        // this.setStorePickup(product, goToCartPage);
      } else if (deliveryType === 'delivery') {
        this.setDelivery(product);
        // this.openPinDialog(product, goToCartPage);
      }
    }
  }

  getProductDeliveryTimeAndStockDetails(): Promise<void> {
    return new Promise((resolve, reject) => {
      const deliveryType = JSON.parse(this.localStorage.getItem("delivery_type")) ?? 'delivery';
      // const apiUrl = deliveryType === 'storePickup' ? this.apiFactory.getStoreMinimumDateTimeDetails : this.apiFactory.getWebOrderMinimumDateTimeDetails;
      const locId = JSON.parse(this.localStorage.getItem('location_code'));
      // const minLocId = deliveryType === 'storePickup' ? locId : null;

      this.cartService.getMinimumDateTimeDetails(this.apiFactory.getWebOrderMinimumDateTimeDetails, this.currentUrl, null).subscribe((data) => {
        if (data) {
          // this.webOrderMinimumDateTimeList.deliveryTime = deliveryType === 'storePickup' ? data?.minOrderTime : data.deliveryTime;
          // this.webOrderMinimumDateTimeList.maxDeliveryTime = deliveryType === 'storePickup' ? data?.maxOrderTime : data.maxDeliveryTime;
          this.webOrderMinimumDateTimeList.deliveryTime = data.deliveryTime;
          this.webOrderMinimumDateTimeList.maxDeliveryTime = data.maxDeliveryTime;


          // const slotApiUrl = deliveryType === 'storePickup' ? this.apiFactory.getTimeSlotDetailsByUrlAndLocId : this.apiFactory.getTimeSlotDetailsByUrl;
          // const slotApiUrl = this.apiFactory.getTimeSlotDetailsByUrl;
          // const slotLocId = deliveryType === 'storePickup' ? locId : null;

          this.cartService.getTimeSlotList(this.apiFactory.getTimeSlotDetailsByUrl, this.currentUrl).subscribe((slotData) => {
            this.timeSlot2 = slotData.map((element) => [element.fromTime, element.toTime]);
            this.timeSlotAvl = this.timeSlot2.map(([fromTime, toTime]) => `${fromTime}-${toTime}`);

            var orderDuration = new Date();
            orderDuration.setHours(orderDuration.getHours() + Number.parseInt(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[0]));
            orderDuration.setMinutes(orderDuration.getMinutes() + Number.parseInt(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[1]));

            let maxOrderDuration = moment().add(Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[0]), "hours")
              .add(Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[1]), "minutes");

            // FETCH ALL STOCK DATA IN ONE CALL
            const productCodes = this.allProductList.map(p => p.product_Code);
            this.productService.getSystemAndManualStockDetails(this.apiFactory.getSystemAndManualStockDetails, locId ?? 0, productCodes, this.currentUrl, deliveryType)
              .subscribe((stockList: WebOrderStockDetailsDto[]) => {

                this.allProductList.forEach((product) => {
                  const stockData = stockList.find(stock => stock.productCode === product.product_Code);
                  const minQty = product.minimum_Order_Quantity || 0;

                  let isAvailable = true; // Default to available

                  if (stockData) {
                    if (stockData.manualStockAllow) {
                      // Check manual stock only
                      if (stockData.manualStock < minQty) {
                        isAvailable = false;
                      } else {
                        isAvailable = true;
                      }
                    } else if (stockData.systemStockAllow) {
                      // Manual not allowed, check system stock
                      if (stockData.systemStock < minQty) {
                        isAvailable = false;
                      } else {
                        isAvailable = true;
                      }
                    }
                    // If neither manual/system allow: keep isAvailable = true
                  }

                  product.outOfStock = !isAvailable;     // For blur + out of stock UI
                  product.stockAvailable = isAvailable;  // For disabling Add to Cart

                  // DELIVERY DATE + TIMESLOT LOGIC (same as before)
                  let minOrderDate = new Date();
                  minOrderDate.setDate(minOrderDate.getDate() + product.minimum_Order_Time);

                  let greaterDate = orderDuration > minOrderDate ? orderDuration : minOrderDate;
                  let todayDate = moment(greaterDate);

                  product.deliveryDate = todayDate.format("YYYY-MM-DD");
                  product.defaultDate = todayDate.format("YYYY-MM-DD");
                  product.deliveryTime = todayDate.format("HH:mm");
                  product.maxDeliveryDate = maxOrderDuration.format("YYYY-MM-DD");
                  product.maxDeliveryTime = maxOrderDuration.format("HH:mm");

                  let totTime = todayDate.hours() * 60 + todayDate.minutes();
                  product.timeSlotAvl = [];
                  let matchedSlot = false;

                  for (const e of this.timeSlot2) {
                    let fromSlotTime = Number(e[0].split(":")[0]) * 60 + Number(e[0].split(":")[1]);
                    if (totTime < fromSlotTime) {
                      let tSlot = `${e[0]}-${e[1]}`;
                      product.timeSlotAvl.push(tSlot);
                      if (!matchedSlot) {
                        product.deliveryTime = tSlot;
                        matchedSlot = true;
                      }
                    }
                  }

                  if (!matchedSlot) {
                    todayDate = todayDate.clone().add(1, 'day');
                    product.deliveryDate = todayDate.format("YYYY-MM-DD");
                    product.timeSlotAvl = this.timeSlot2.map(slot => `${slot[0]}-${slot[1]}`);
                    product.deliveryTime = product.timeSlotAvl[0];
                  }

                  const today = moment().startOf('day');
                  const deliveryDay = todayDate.clone().startOf('day');

                  if (deliveryDay.isSame(today, 'day')) {
                    product.deliveryLabel = 'Today';
                  } else if (deliveryDay.diff(today, 'days') === 1) {
                    product.deliveryLabel = 'Tomorrow';
                  } else {
                    product.deliveryLabel = deliveryDay.format('Do MMM');
                  }
                });
                // console.log(this.productList);
                resolve();
              }, reject);
          }, reject);
        } else {
          reject("Invalid delivery data");
        }
      }, reject);
    });
  }

  setDelivery(product: Product) {
    let selfLife = JSON.parse(this.localStorage.getItem("min_selflife"));
    if (product.shelf_Life_In_Hours >= selfLife) {
      product.cartProductType = "Product";
      this.getProductWithStock(product);
    } else {
      this.toastrService.showErrorToast("Cannot add to cart, shelf life is under " + selfLife + " hours.");
    }
  }

  getProductWithStock(product: Product) {
    if (this.checkAllowStockSubscription) return;

    const locId = JSON.parse(this.localStorage.getItem('location_code'));
    const deliveryType = JSON.parse(this.localStorage.getItem("delivery_type")) ?? 'delivery';

    if (!locId) {
      this.toastrService.showErrorToast("Location can't place order");
      return;
    }

    this.checkAllowStockSubscription = this.productService
      .getSystemAndManualStockDetails(this.apiFactory.getSystemAndManualStockDetails, locId, [product.product_Code], this.currentUrl, deliveryType)
      .subscribe({
        next: (data: WebOrderStockDetailsDto[]) => {
          this.checkAllowStockSubscription = null;

          const stockData = data?.[0]; // Get the stock data for this single product
          if (!stockData) {
            this.toastrService.showErrorToast(`${product.product_Name} stock data not found.`);
            return;
          }

          const minQty = product.minimum_Order_Quantity || 0;

          // Check Manual Stock first
          if (stockData.manualStockAllow) {
            if (stockData.manualStock < minQty) {
              this.toastrService.showErrorToast(`${product.product_Name} is out of stock, available: ${stockData.manualStock}`);
              return;
            }
            this.getDesignBySubGroupAndUrl(product);
            return;
          }

          // Then check System Stock
          if (stockData.systemStockAllow) {
            if (stockData.systemStock < minQty) {
              this.toastrService.showErrorToast(`${product.product_Name} is out of stock, available: ${stockData.systemStock}`);
              return;
            }
            this.getDesignBySubGroupAndUrl(product);
            return;
          }

          // If neither manual nor system stock check is allowed, proceed anyway
          this.getDesignBySubGroupAndUrl(product);
        },
        error: (error: HttpErrorResponse) => {
          this.checkAllowStockSubscription = null;
          this.toastrService.showErrorToast('Something went wrong while checking stock.');
        }
      });
  }

  getDesignBySubGroupAndUrl(product: Product) {
    const cartProducts: Product[] = JSON.parse(this.localStorage.getItem('avct_item')) || [];
    if (cartProducts.some((temp) => temp.product_Code == product.product_Code)) {
      // if (goToCartPage) {
      //   this.productService.navigateToCart(product);
      // }
      // else {
      //   this.toastrService.showErrorToast(product.product_Name + ' is already added to cart');
      //   return;
      // }
    }
    this.getDesignSubscription = this.productService.getWebOrderDesigns(this.apiFactory.getWebOrderDesignBySubgroupAndUrl, product.productSubGroup.refNo, this.currentUrl)
      .subscribe((data) => {
        console.log(data);
        if (data.length > 0) {
          // this.designProducts = data;
          // const cartProducts: Product[] = JSON.parse(this.localStorage.getItem('avct_item')) || [];
          // let designIndex = cartProducts.findIndex((e) => e.designForProductCode === product.product_Code);
          // if (designIndex >= 0) {
          //   this.designProducts.map((e) => (e.is_Default = false));
          //   this.designProducts.filter((item) => item.product_Code == cartProducts[designIndex].product_Code).map((e) => (e.is_Default = true));
          // }
          // this.openDesignDialog(product, this.designProducts, goToCartPage);
        } else {
          console.log("sunil")
          if (product.offerDetails?.length > 0)
            this.openOfferDialog(product, null);
          else {
            this.productService.addToCart1(product);

            // if (goToCartPage) {
            //   this.productService.navigateToCart(product);
            // }
          }
          // this.toastrService.showErrorToast('No design available');
        }
      });
  }

  offerObj: any;
  productOffer: Product;
  discountOffer: number;
  bulkDiscountOffer: BulkDiscountDto;

  openOfferDialog(product: Product, design: Product) {
    console.log(product);
    const cartProducts: Product[] = JSON.parse(this.localStorage.getItem('avct_item')) || [];
    if (cartProducts.some((temp) => temp.product_Code == product.product_Code)) {
      // if (goToCartPage) {
      //   this.productService.navigateToCart(product);
      // }
      // else {
      //   this.toastrService.showErrorToast(product.product_Name + ' is already added to cart');
      //   return;
      // }
    }
    let offers: ViewOfferSetUpDto[] = product.offerDetails;
    let appliedOfferId: string = product.offerId
      ? product.offerId
      : product.offerDetails[0].offerId;
    const dialogRef = this.dialog.open(OfferDialogComponent, {
      width: '500px',
      height: '300px',
      data: { offers, appliedOfferId },
    });

    dialogRef.afterClosed().subscribe((offerObj) => {
      console.log(offerObj);
      if (offerObj) {
        this.offerObj = offerObj;
        //conditions
        var orderQuantity;
        var freeByProductCode;
        var cartProductType;

        if (product) {
          product.orderQuantity = Math.max(offerObj.minQty, offerObj.buyQty);
          // product.orderQuantity = offerObj.minQty;
          orderQuantity = product.orderQuantity;
          freeByProductCode = product.product_Code;
          cartProductType = product.cartProductType;
          if (product.cartProductType == 'Product') {
            product.basePremiumFlavourPrice = 0;
            product.premiumFlavourPrice = 0;
          }
        }
        console.log(product);

        // if (design) {
        //   this.productService.addToCartDesign(product, design);
        // }
        // else if (product.offerDetails[0].minQty > 1) {
        //   this.productService.addToCart(product);
        // }

        if (offerObj.schemeType == 'Buy 1 get 1 Free' || offerObj.schemeType == 'Buy X get Y Free') {
          this.productOfferSubscription = this.productService.getProductOfferDetails(this.apiFactory.productOfferDetails, offerObj.offerId, orderQuantity)
            .subscribe(
              (data) => {
                // offer processing
                this.productOffer = data;
                //set order qty as product QTY IN CART
                this.productOffer.product_Name = this.productOffer.product_Name.concat('(').concat(offerObj.schemeType).concat(')');
                const freeQty = Math.floor(orderQuantity / offerObj.buyQty) * offerObj.getQty;
                this.productOffer.orderQuantity = freeQty;
                // this.productOffer.orderQuantity = orderQuantity;
                this.productOffer.minimum_Order_Quantity = offerObj.minQty;
                // this.productOffer.net_Sale_Price = offerObj.productPriceForCustomer;
                this.productOffer.sale_Price = Number((this.productOffer.priceForCustomer / (1 + (this.productOffer.tax.taxRate / 100) + (this.productOffer.cess.cessRate / 100))));
                this.productOffer.discountAmt = 0;
                this.productOffer.discountRate = 0;
                var taxableAmt = this.productOffer.sale_Price - ((this.productOffer.sale_Price * this.productOffer.discountRate) / 100);
                var cess = this.productOffer.cess.cessRate;
                var tax = this.productOffer.tax.taxRate;
                var cessAmt = (cess / 100) * taxableAmt;
                var cgst = (this.productOffer.tax.taxRate / 2 / 100) * taxableAmt;
                var sgst = (this.productOffer.tax.taxRate / 2 / 100) * taxableAmt;
                var tot = cgst + sgst;
                this.productOffer.taxAmount = tot;
                this.productOffer.cgstAmt = cgst;
                this.productOffer.sgstAmt = sgst;
                this.productOffer.cessAmount = cessAmt;
                this.productOffer.net_Sale_Price = taxableAmt + tot + cessAmt;
                this.productOffer.cessRate = cess;
                this.productOffer.taxRate = tax;
                this.productOffer.freeProductNetSalePrice = offerObj.netSalePrice;
                this.productOffer.freeByProductCode = freeByProductCode;
                this.productOffer.cartProductType = cartProductType;
                this.productOffer.product_Type = this.productOffer.product_Type;
                this.productOffer.product_Unit = this.productOffer.product_Unit;
                this.productOffer.food_Type = this.productOffer.food_Type;
                this.productOffer.hsn_Code = this.productOffer.hsn_Code;
                this.productOffer.deliveryDate = product.deliveryDate;
                this.productOffer.timeSlotAvl = product.timeSlotAvl;
                this.productOffer.deliveryTime = product.deliveryTime;
                this.productOffer.deliveryLabel = product.deliveryLabel;

                // main product tax and net amount calculations
                product.discountAmt = 0;
                product.discountRate = 0;
                var taxableAmt = product.sale_Price - (product.sale_Price * 0) / 100;
                taxableAmt = taxableAmt + product.basePremiumFlavourPrice;
                var cess = product.cess.cessRate;
                var cessAmt = (cess / 100) * taxableAmt;
                var cgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var sgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var tot = cgst + sgst;
                product.promotionOfferId = offerObj.offerId;
                product.offerId = offerObj.offerId;
                product.taxAmount = tot; //Tax Amount
                product.cgstAmt = cgst;
                product.sgstAmt = sgst;
                product.cessAmount = cessAmt;
                product.net_Sale_Price = taxableAmt + tot + cessAmt;
                console.log(product);
                console.log(this.productOffer);
                this.productService.addToCartWithOffer(product, this.productOffer, design);

                // if (goToCartPage) {
                //   this.productService.navigateToCart(product);
                // }
              },
              (err) => {
                if (err.error) {
                  this.toastrService.showErrorToast(err.error.message);
                }
              }
            );
        } else {
          if (offerObj.schemeType == 'Buy x get x percent off') {
            this.productDiscountSubscription = this.productService
              .getProductDiscountDetails(
                this.apiFactory.productDiscountDetails,
                offerObj.offerId,
                orderQuantity
              )
              .subscribe(
                (data) => {
                  console.log(data);
                  this.discountOffer = data;
                  product.discountAmt =
                    (this.discountOffer / 100) * product.sale_Price;
                  product.discountRate = this.discountOffer;
                  var taxableAmt =
                    product.sale_Price -
                    (product.sale_Price * this.discountOffer) / 100;
                  taxableAmt = taxableAmt + product.basePremiumFlavourPrice;
                  var cess = product.cess.cessRate;
                  var cessAmt = (cess / 100) * taxableAmt;
                  var cgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                  var sgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                  var tot = cgst + sgst;
                  product.promotionOfferId = offerObj.offerId;
                  product.offerId = offerObj.offerId;
                  product.taxAmount = tot; //Tax Amount
                  product.cgstAmt = cgst;
                  product.sgstAmt = sgst;
                  product.cessAmount = cessAmt;
                  product.net_Sale_Price = taxableAmt + tot + cessAmt;
                  this.productService.addToCartWithOffer(product, null, design);

                  // if (goToCartPage) {
                  //   this.productService.navigateToCart(product);
                  // }
                },
                (err) => {
                  if (err.error) {
                    this.toastrService.showErrorToast(err.error.message);
                  }
                }
              );
          } else {
            this.productBulkDiscountSubscription = this.productService
              .getProductBulkDiscountDetails(
                this.apiFactory.productBulkOfferDetails,
                offerObj.offerId
              )
              .subscribe((data) => {
                this.bulkDiscountOffer = data;
                product.discountAmt =
                  (this.bulkDiscountOffer.discount / 100) * product.sale_Price;
                product.discountRate = this.bulkDiscountOffer.discount;
                var taxableAmt =
                  product.sale_Price -
                  (product.sale_Price * this.bulkDiscountOffer.discount) / 100;
                taxableAmt = taxableAmt + product.basePremiumFlavourPrice;
                var cess = product.cess.cessRate;
                var cessAmt = (cess / 100) * taxableAmt;
                var cgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var sgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var tot = cgst + sgst;
                product.promotionOfferId = offerObj.offerId;
                product.offerId = offerObj.offerId;
                product.taxAmount = tot; //Tax Amount
                product.cgstAmt = cgst;
                product.sgstAmt = sgst;
                product.cessAmount = cessAmt;
                product.net_Sale_Price = taxableAmt + tot + cessAmt;
                this.productService.addToCartWithOffer(product, null, design);

                // if (goToCartPage) {
                //   this.productService.navigateToCart(product);
                // }
              });
          }
        }

      } else {
        // if (design)
        //   this.productService.addToCartDesign(product, design);
        // else
        //   this.productService.addToCart(product);
      }
    });
  }

  // get filteredItems(): MenuItem[] {
  //   return this.items.filter(item => {
  //     const matchesSearch = item.name.toLowerCase().includes(this.searchQuery.toLowerCase());
  //     const matchesFilter =
  //       this.filterType === 'all' ||
  //       (this.filterType === 'veg' && item.veg) ||
  //       (this.filterType === 'nonveg' && !item.veg);
  //     return matchesSearch && matchesFilter;
  //   });
  // }

  getCartQuantity(itemId: number): number {
    return this.cartService.getItemQuantity(itemId);
  }

  // addToCart(item: MenuItem) {
  //   if (this.restaurant) {
  //     this.cartService.addToCart(item, this.restaurant.id, this.restaurant.name);
  //   }
  // }

  addToCart1(item: Product) {
    if (this.restaurant) {
      this.cartService.addToCart(item, this.restaurant.id, this.restaurant.name);
    }
  }

  updateQuantity(itemId: number, quantity: number) {
    this.cartService.updateQuantity(itemId, quantity);
  }

  goBack() {
    this.router.navigate(['/']);
  }

  goToCart() {
    this.router.navigate(['/cart']);
  }

  // async openDeliveryTypeDialog(product: Product) {
  //   // let deliveryType = JSON.parse(this.localStorage.getItem('delivery_type'));
  //   let locId = JSON.parse(this.localStorage.getItem('location_code'));
  //   console.log('Location ID:', locId);
  //   if (!locId) {
  //     // const dialogRef = this.dialog.open(StorePickupDialogComponent, {
  //     //   width: '300px',
  //     //   autoFocus: false,
  //     //   panelClass: 'store-dialog-container'
  //     // });

  //     // dialogRef.afterClosed().subscribe(async result => {
  //     // console.log(result)
  //     // if (result) {
  //     await this.getProductDeliveryTimeAndStockDetails(); // wait for API to update productList
  //     const updatedProduct = this.productList.find(p => p.product_Code === product.product_Code);
  //     // if (result === 'storePickup') {
  //     //   this.setStorePickup(updatedProduct, goToCartPage);
  //     // } else if (result === 'delivery') {
  //     this.setDelivery(updatedProduct);
  //     // this.openPinDialog(product, goToCartPage);
  //   }
  //   // }
  //   // });
  //   // } else {
  //   //   if (deliveryType === 'storePickup') {
  //   //     this.setStorePickup(product, goToCartPage);
  //   // } else if (deliveryType === 'delivery') {
  //   this.setDelivery(product);
  //   // this.openPinDialog(product, goToCartPage);
  //   // }
  //   // }
  // }

  // setFilter(type: 'all' | 'veg' | 'nonveg') {
  //   this.filterType = type;

  //   if (type === 'all') {
  //     this.selectedSubGroup = null; // 👈 reset subgroup
  //   }
  // }

  // selectSubGroup(group: string) {
  //   this.selectedSubGroup = group;

  //   // 👇 Just ensure subgroup applies
  //   if (this.filterType === 'all') {
  //     this.filterType = null;
  //     // do nothing, filtering logic will handle it
  //   }
  // }

  setFilter(type: 'all' | 'veg' | 'nonveg') {
    // 👇 Toggle logic
    if (this.filterType === type) {
      this.filterType = null;   // deselect if clicked again
    } else {
      this.filterType = type;
    }

    // 👇 If "all" is selected, reset subgroup
    if (this.filterType === 'all') {
      this.selectedSubGroup = null;
    }
  }

  selectSubGroup(group: string) {
    // 👇 Toggle subgroup
    if (this.selectedSubGroup === group) {
      this.selectedSubGroup = null;  // deselect on second click
    } else {
      this.selectedSubGroup = group;
    }

    // 👇 Optional: reset filterType when subgroup selected
    if (this.selectedSubGroup) {
      this.filterType = null;
    }
  }

  get filteredItems(): Product[] {
    const search = (this.searchQuery || '').toLowerCase();

    return this.items.filter(item => {

      const matchesSearch =
        item.product_Name?.toLowerCase().includes(search);

      const matchesFilter =
        this.filterType === 'all' ||
        this.filterType === null ||   // 👈 important
        (this.filterType === 'veg' && item.food_Type === 'Veg') ||
        (this.filterType === 'nonveg' && item.food_Type === 'Non-Veg');

      const matchesSubGroup =
        !this.selectedSubGroup ||
        item.productSubGroup?.productSubGroupName === this.selectedSubGroup;

      return matchesSearch && matchesFilter && matchesSubGroup;
    });
  }
  // redirectToPartner(restaurantId: number, type: string) {
  //   console.log("restaurant id " + restaurantId, type)
  //   const restaurantData = this.aggregatorSetup?.[restaurantId];
  //   if (!restaurantData) {
  //     return;
  //   }
  //   // const partner = restaurantData.find(a =>
  //   //   a?.aggregatorType?.toUpperCase() === type.toUpperCase()
  //   // );
  //   const partner = restaurantData?.aggregatorRestaurantSetUp?.find(
  //     (a: any) =>
  //       a?.aggregatorType?.toUpperCase() === type.toUpperCase()
  //   );
  //   if (partner?.restaurantUrl) {
  //     window.open(partner.restaurantUrl, '_blank');
  //   } else {
  //     this.toastrService.showErrorToast("No aggregator found");
  //   }
  // }

  redirectToPartner(restaurantId: number, type: string) {
    if (!this.aggregatorSetup?.length) {
      this.toastrService.showErrorToast('No aggregator found');
      return;
    }

    const partner = this.aggregatorSetup.find(
      (item: any) =>
        item.restaurantRefNo === restaurantId &&
        item.aggregator?.toUpperCase() === type.toUpperCase()
    );

    if (partner?.restaurantUrl) {
      window.open(partner.restaurantUrl, '_blank');
    } else {
      this.toastrService.showErrorToast(`No ${type} link found`);
    }
  }

  selectedItem: any = null;

  openPrebookPopup(item: any) {
    this.selectedItem = item;
  }

  closePopup() {
    this.selectedItem = null;
  }

  isDesktop = window.innerWidth >= 768;

  @HostListener('window:resize', [])
  onResize() {
    this.isDesktop = window.innerWidth >= 768;
  }

  isSticky = false;
  @HostListener('window:scroll', [])
  onScroll() {
    const scrollY = window.scrollY;

    // when user scrolls past hero (400px)
    this.isSticky = scrollY > 200;
  }

}